import { componentStyle } from '@/styling/util/component-style.ts';
import type { DialogDesignTokens } from '@primeuix/themes/types/dialog';

export const dialogStyle = componentStyle<DialogDesignTokens>({
    root: {
        borderRadius: '4px',
    },
});
